<template>
  <div class="class-admin-container">
    <v-head ref="headRef"></v-head>
    <ti-header ref="tiHeaderWorkRef" :pathString="path"></ti-header>
    <router-view></router-view>
    <v-footer></v-footer>
  </div>
</template>
<script>
import vHead from "./Head";
import tiHeader from "./TiHeaderWork";
import vFooter from "./Footer";
export default {
  components: {
    vHead,
    tiHeader,
    vFooter,
  },
  data() {
    return {
      path: '/'
    };
  },
  created() {
    this.path = this.$route.path;
  },
  beforeUpdate() {
    this.path = this.$route.path;
  },

};
</script>
<style scoped></style>
